import { NavLink, useNavigate } from 'react-router-dom';
import type { ReactNode } from 'react';
import { api, clearToken } from '../lib/api';
import { Orb } from './Orb';
import { NotificationBell } from './NotificationBell';

const NAV: Array<{ to: string; label: string; icon: string }> = [
  { to: '/', label: 'Dashboard', icon: '◧' },
  { to: '/board', label: 'Board', icon: '▦' },
  { to: '/feed', label: 'Feed', icon: '≋' },
  { to: '/approvals', label: 'Approvals', icon: '✓' },
  { to: '/agents', label: 'Agents', icon: '◍' },
  { to: '/brains', label: 'Brains', icon: '✦' },
  { to: '/knowledge', label: 'Knowledge', icon: '❋' },
  { to: '/reports', label: 'Reports', icon: '▤' },
  { to: '/how-it-works', label: 'How it works', icon: '✧' },
  { to: '/settings', label: 'Settings', icon: '⚙' },
];

function setTheme(t: 'dark' | 'light') {
  document.documentElement.setAttribute('data-theme', t);
  try {
    localStorage.setItem('hq-theme', t);
  } catch {
    /* ignore */
  }
}

export function Layout({ title, actions, children }: { title?: string; actions?: ReactNode; children: ReactNode }) {
  const nav = useNavigate();
  const theme = document.documentElement.getAttribute('data-theme') === 'light' ? 'light' : 'dark';
  return (
    <div className="app">
      <aside className="sidebar">
        <div className="brandrow">
          <Orb agent="emma" size="xs" />
          <span className="word">PuppyPad HQ</span>
        </div>
        <nav className="nav">
          {NAV.map((n) => (
            <NavLink key={n.to} to={n.to} end={n.to === '/'}>
              <span aria-hidden>{n.icon}</span>
              {n.label}
            </NavLink>
          ))}
        </nav>
      </aside>
      <main className="content">
        <div className="topbar">
          <h1 style={{ fontWeight: 250 }}>{title}</h1>
          <div style={{ display: 'flex', gap: 10, alignItems: 'center' }}>
            {actions}
            <NotificationBell />
            <div className="toggle" role="group" aria-label="Theme">
              <button className={theme === 'dark' ? 'active' : ''} onClick={() => setTheme('dark')}>
                NIGHTOPS
              </button>
              <button className={theme === 'light' ? 'active' : ''} onClick={() => setTheme('light')}>
                DAYLIGHT
              </button>
            </div>
            <button
              className="btn btn-ghost sm"
              onClick={async () => {
                await api.post('/auth/logout').catch(() => {});
                clearToken();
                nav('/login');
              }}
            >
              Sign out
            </button>
          </div>
        </div>
        {children}
      </main>
    </div>
  );
}
